export const rfc_pattern_pm = "^(([A-Z�&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
"(([A-Z�&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
"(([A-Z�&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
"(([A-Z�&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";

export const rfc_pattern_pf = "^(([A-Z�&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
  "(([A-Z�&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
  "(([A-Z�&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
  "(([A-Z�&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$";

export function validateRFC(rfc, moral = null) {
    if (moral == null) {
        if (rfc.length > 0) {
            if (rfc.match(rfc_pattern_pm) || rfc.match(rfc_pattern_pf)) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    } else {
        if (rfc.length > 0) {
            if ((moral && rfc.match(rfc_pattern_pm)) || (!moral && rfc.match(rfc_pattern_pf))){
                return true;
            } else {
                return false;
            }
        }
    }

    return false;
}

export function validateRFCFisica(rfc) {
    if (rfc.length > 0) {
        if (rfc.match(rfc_pattern_pf)) {
            return true;
        } else {
            return false;
        }
    }
    return false;
}

export function getErrorsMessage(error) {
    if ("errors" in error.response.data) {
        var message = "";
        for (var e in error.response.data["errors"]) {
            for (var m in error.response.data["errors"][e]) {
                if (message.length > 0) {
                    message += ", ";
                }
                message += error.response.data["errors"][e][m];
            }
        }
        return message;
    }
    if ("error" in error.response.data) {
        return error.response.data["error"];
    }
    if ("msg" in error.response.data) {
        return error.response.data["msg"];
    }
    return error.response.data["message"];
}

export function getSuccessMessage(response) {
    return response.data["message"];
}

// Exportación global para mantener compatibilidad con código existente
window.rfc_pattern_pm = rfc_pattern_pm;
window.rfc_pattern_pf = rfc_pattern_pf;
